export default __webpack_public_path__ + "static/media/blog1.13c40caf.jpg";